<template>
  <div class="k-address">

    <el-row :gutter="20" class="k-address__header">
      <el-col :span="8" class="k-address__label"><h3 v-if="number !== undefined">Адрес {{number + 1}}</h3></el-col>
      <el-col :span="16">
        <el-tooltip content="Удалить" placement="top">
          <el-button @click="handleDelete" type="danger" icon="el-icon-delete" circle size="mini"></el-button>
        </el-tooltip>
      </el-col>
    </el-row>

    <el-row :gutter="20" class="k-address__param">
      <el-col :span="8" class="k-address__label">Адрес:</el-col>
      <el-col :span="16"><el-input placeholder="Адрес" v-model="localValue.address"></el-input></el-col>
    </el-row>

    <el-row :gutter="20" class="k-address__param">
      <el-col :span="8" class="k-address__label">Город:</el-col>
      <el-col :span="16">
        <el-select v-if="cities.length" v-model="localValue.city" filterable placeholder="Город">
          <el-option
            label="Оберіть місто"
            :value="null"
          />
          <el-option
            v-for="item in cities"
            :key="item._id"
            :label="item.name"
            :value="item.name"
          />
        </el-select>
      </el-col>
    </el-row>

    <el-row :gutter="20" class="k-address__param">
      <el-col :span="8" class="k-address__label">Широта (lat):</el-col>
      <el-col :span="16"><el-input placeholder="Широта" v-model="localValue.lat"></el-input></el-col>
    </el-row>

    <el-row :gutter="20" class="k-address__param">
      <el-col :span="8" class="k-address__label">Долгота (lng):</el-col>
      <el-col :span="16"><el-input placeholder="Долгота" v-model="localValue.lng"></el-input></el-col>
    </el-row>
  </div>
</template>

<script>
/**
 * Component: k-address - Компонент для редактирвания адресе акции
*
* @version 1.0.0
*/


export default {
  name: 'k-address',

  props: {
    address: {
      type: Object,
    },

    number: {
      type: Number,
    },

    cities: {
      type: Array,
      require: true,
    },
  },

  computed: {
    localValue: {
      get() {
        return this.address;
      },

      set(value) {
        this.$emit('input', value);
      },
    },
  },

  methods: {
    handleDelete() {
      this.$emit('delete');
    },
  },
};
</script>

<style lang="scss">
@import '~@/scss/styles';

.k-address {
  $this: &;

  &__header {
    display: flex;
    align-items: center;
  }

  &__param {
    margin-bottom: $vp;

    .el-select {
      width: 100%;
    }
  }

  &__label {
    line-height: 40px;
    text-align: right;
    padding-right: $hp;
  }
}
</style>
